var _defs, _rect, _rect2, _rect3, _circle, _line, _rect4, _circle2, _line2, _rect5, _circle3, _line3, _rect6, _circle4, _line4, _rect7, _circle5, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _rect8, _rect9, _path, _ellipse, _polygon, _polygon2, _path2, _path3, _path4, _path5, _ellipse2, _ellipse3, _path6, _path7, _path8, _rect10, _rect11, _path9, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _circle6, _circle7, _line14, _line15, _line16, _path10, _line17, _path11, _path12, _path13, _path14, _rect25, _circle8, _polygon3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfiguration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vector",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 1200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f3f3f3;}.cls-2{fill:#dfdfdf;}.cls-13,.cls-16,.cls-17,.cls-18,.cls-3,.cls-4{fill:none;}.cls-16,.cls-3,.cls-4{stroke:#f3f3f3;}.cls-13,.cls-16,.cls-18,.cls-3,.cls-4{stroke-linecap:round;stroke-linejoin:round;}.cls-17,.cls-18,.cls-3{stroke-width:4px;}.cls-4{stroke-width:2px;}.cls-5{fill:#d0d0d0;}.cls-6{fill:#de8e68;}.cls-7{fill:#56cad8;}.cls-8{fill:#74d5de;}.cls-9{fill:#fcc486;}.cls-10{fill:#fed385;}.cls-11{fill:#fd8369;}.cls-12{fill:#fed892;}.cls-13{stroke:#d0d0d0;}.cls-13,.cls-16{stroke-width:3px;}.cls-14{fill:#dedede;}.cls-15{fill:#fff;}.cls-17,.cls-18{stroke:#dfdfdf;}.cls-17{stroke-miterlimit:10;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 805.83,
    y: 528.44,
    width: 238.44,
    height: 459.21,
    transform: "translate(1850.1 1516.1) rotate(-180)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1043.61,
    y: 528.44,
    width: 55.46,
    height: 459.21,
    transform: "translate(2142.69 1516.1) rotate(-180)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 825.59,
    y: 557.5,
    width: 198.93,
    height: 38.35,
    transform: "translate(1850.1 1153.34) rotate(-180)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 839.88,
    cy: 571.86,
    r: 6.73
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 955.82,
    y1: 571.86,
    x2: 852.26,
    y2: 571.86
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 825.59,
    y: 622.32,
    width: 198.93,
    height: 38.35,
    transform: "translate(1850.1 1282.98) rotate(-180)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 839.88,
    cy: 636.68,
    r: 6.73
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 955.82,
    y1: 636.68,
    x2: 852.26,
    y2: 636.68
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 825.59,
    y: 687.13,
    width: 198.93,
    height: 38.35,
    transform: "translate(1850.1 1412.62) rotate(-180)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 839.88,
    cy: 701.49,
    r: 6.73
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 955.82,
    y1: 701.49,
    x2: 852.26,
    y2: 701.49
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 825.59,
    y: 751.95,
    width: 198.93,
    height: 38.35,
    transform: "translate(1850.1 1542.25) rotate(-180)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 839.88,
    cy: 766.31,
    r: 6.73
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 955.82,
    y1: 766.31,
    x2: 852.26,
    y2: 766.31
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 825.59,
    y: 816.77,
    width: 198.93,
    height: 38.35,
    transform: "translate(1850.1 1671.89) rotate(-180)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 839.88,
    cy: 831.13,
    r: 6.73
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 955.82,
    y1: 831.13,
    x2: 852.26,
    y2: 831.13
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1086.26,
    y1: 585.08,
    x2: 1056.42,
    y2: 585.08
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1086.26,
    y1: 592.81,
    x2: 1056.42,
    y2: 592.81
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1086.26,
    y1: 637.63,
    x2: 1056.42,
    y2: 637.63
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1086.26,
    y1: 645.35,
    x2: 1056.42,
    y2: 645.35
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1086.26,
    y1: 701.49,
    x2: 1056.42,
    y2: 701.49
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1086.26,
    y1: 709.22,
    x2: 1056.42,
    y2: 709.22
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1086.26,
    y1: 763.28,
    x2: 1056.42,
    y2: 763.28
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1086.26,
    y1: 771,
    x2: 1056.42,
    y2: 771
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 85.37,
    y: 371.38,
    width: 423.15,
    height: 241.03
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 117.72,
    y: 409.37,
    width: 239.85,
    height: 174.14,
    rx: 23.65,
    ry: 23.65
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M736,633.53c4,3.31,32.71,25.1,44.47,38.89,10.91,3,58.19,21,99.55,27.32-.13,5.83-3.12,25.25-3.12,25.25s-99.55-12.37-111.55-15.66-58.76-31.67-69-42.4C710,652.49,736,633.53,736,633.53Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 890.7,
    cy: 713.18,
    rx: 22.3,
    ry: 16.54
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "576.29 782.89 576.29 999.96 650.07 999.96 613.18 785.24 576.29 782.89"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "700.05 791.48 700.05 999.96 640.75 999.96 592.83 780.67 700.05 791.48"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M561.13,640.27c-3.37,3.65-12.91,15.43-15.43,19.92-6.45-5.61-114.47-104.93-117-104.93a4.57,4.57,0,0,0-4.49,4.21c0,13.16,9.6,13.81,21.52,26.45,25,44.87,84.89,126.17,100.52,126.17,9,0,46.57-36.68,46.57-41.49S561.13,640.27,561.13,640.27Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M613.56,586.25c-25-15.1-64.77,40.28-64,49.54S587.06,672,602.4,669C612.46,667,639.69,602,613.56,586.25Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M648.48,568.27c74.15,0,69.31,210.22,56.17,220.84-16.35,13.22-122.47,1-128.36-6.22S566.07,568.27,648.48,568.27Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M669.32,580.66c0,6.2-34.37,7.53-34.37,0v-42.2h34.37Z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 646.91,
    cy: 520.4,
    rx: 41.37,
    ry: 30.79,
    transform: "translate(-74.87 930.68) rotate(-68.43)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 674.4,
    cy: 535.13,
    rx: 9.87,
    ry: 6.9,
    transform: "matrix(0.58, -0.81, 0.81, 0.58, -153.33, 771.84)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M703.29,515.32c0-5.73-5.35-12-6.36-19.25-.52-3.65.61-18.84-3.65-24-8.85-10.65-14.08-8.47-20.85-11-11.8-4.31-16.32-11.46-26.06-11.46-11.06,0-15.53,5.73-23.45,5.73-9.06,0-16.48-4.17-29.19-4.17-6.78,0-15.64,8.86-15.64,16.68,0,18.48,17.2,15.83,17.2,20.33,0,3.12-1,5.6-1,9.9,0,5.6,7.3,8.86,11.47,8.86,12.7,0,14.38-1.55,14.38-1.55a59.87,59.87,0,0,1,9.57-13.83c.51-.54,8.76,5.29,22.23,5.74,11.05.37,18.82,2.5,18.82,7.65,0,3.63-1.33,14.42-1.25,17.46s1.16,5,1.84,5,1.06-1,5.3-1c4.55,0,4.9,5.59,5.69,5.59C686.87,532.1,703.29,528.39,703.29,515.32Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M682.23,589.43c25-15.11,64.78,40.28,64,49.53s-37.46,36.2-52.81,33.21C683.34,670.21,656.11,605.21,682.23,589.43Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M448.33,583.72a22.24,22.24,0,1,0,31.55,29.42Z"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 206.62,
    y: 161.01,
    width: 301.9,
    height: 178.99
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 82.17,
    y: 159.02,
    width: 106.18,
    height: 178.99
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M238.87,314c8.78-10.54,24.36-28.45,52.7-34.54,42.34-9.11,54.59-58.56,74.94-58.56,25.54,0,36.3,14.64,46.84,14.64,21.16,0,43.39-19.62,55-48.6"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 97.84,
    y: 187.34,
    width: 74.99,
    height: 6.86
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 97.84,
    y: 210.44,
    width: 74.99,
    height: 6.86
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 97.84,
    y: 233.54,
    width: 74.99,
    height: 6.86
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 97.67,
    y: 256.64,
    width: 74.99,
    height: 6.86
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 97.67,
    y: 279.74,
    width: 74.99,
    height: 6.86
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 97.67,
    y: 302.84,
    width: 74.99,
    height: 6.86
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 135.31,
    y: 432.9,
    width: 101.24,
    height: 6.86
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 135.31,
    y: 456,
    width: 101.24,
    height: 6.86
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 135.31,
    y: 479.1,
    width: 101.24,
    height: 6.86
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 135.09,
    y: 502.2,
    width: 101.24,
    height: 6.86
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 135.09,
    y: 525.3,
    width: 101.24,
    height: 6.86
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 135.09,
    y: 548.39,
    width: 101.24,
    height: 6.86
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 277.48,
    y: 393.84,
    width: 170.13,
    height: 102.6,
    rx: 23.65,
    ry: 23.65
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 358.45,
    cy: 406.97,
    r: 5.72
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 358.45,
    cy: 483.32,
    r: 5.72
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 358.45,
    y1: 408.84,
    x2: 358.45,
    y2: 481.7
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 372.34,
    y1: 418.39,
    x2: 372.34,
    y2: 460.88
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 358.45,
    y1: 483.32,
    x2: 372.34,
    y2: 460.88
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M892.28,399.51a40.69,40.69,0,0,1,43.17-67,56.4,56.4,0,0,1,99.15,8.79,40.69,40.69,0,0,1,50.4,58.23Z"
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 1063.03,
    y1: 396.11,
    x2: 1063.03,
    y2: 533.2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M799.73,472.08c7.14,13.75,23.06,18.81,35.39,18.81,29.78,0,41.15-28.69,41.15-38.39"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M797.85,327.2c6.58,12.51,9.84,25.74,9.84,37.3,0,27.38-4.57,46.15-8,62.57"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M647.56,309.2c20.16-16.83,42.82-29.34,69.79-29.34,22.16,0,40.15,6.6,54.07,16.67"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M539,396.62c21.13,0,40.46-18,61.13-39.87"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 607.27,
    y: 315.33,
    width: 29.78,
    height: 29.78
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 784.78,
    cy: 309.61,
    r: 13.08
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "821.07 450.22 791.93 431.24 790.06 465.97 821.07 450.22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfiguration);
export default __webpack_public_path__ + "static/media/configuration.cdf7b603ec2ec401fca1af7ac9561b24.svg";
export { ForwardRef as ReactComponent };